import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { USER } from '../../../data/reducer';
import { formatDate } from '../../../utils/TimeUtils';

const { id: module_id } = module;

const docStatus = {
  OPEN: 'OPEN',
  OPENED: 'OPENED',
  CLOSED: 'CLOSED',
};

const UserInfoRequest = ({ request, hasActiveSuomiFiInbox }) => {
  return (
    <div className="userinfo-request-list userinfo-request">
      <div className="userinfo-request__row">
        <div className="userinfo-request__info">
          <p>
            <b>{request.title}</b>
          </p>
          <FormattedMessage
            id={`${module_id}.request_date`}
            values={{
              date: formatDate(request.createdDate),
            }}
          />
          {request.nativeId && (
            <p>
              <FormattedMessage id={`${module_id}.caseid`} /> {request.nativeId}
            </p>
          )}
        </div>
        <div className="userinfo-request__status ot-status">
          {request.status ? (
            <>
              <FormattedMessage
                id={`${module_id}.status.${request.status}`}
              />
              &nbsp;
              {request.status === docStatus.CLOSED &&
                formatDate(request.closedDate)}
            </>
          ) : (
            <FormattedMessage id="information.missing" />
          )}
        </div>
      </div>
      {request.status === docStatus.CLOSED && (
        <div className="userinfo-request__row userinfo-request__actions">
          {hasActiveSuomiFiInbox ? (
            <a
              className="ot-button ot-button--light pull-left"
              href="https://www.suomi.fi/viestit"
              target="_blank"
            >
              <i className="icon-external-link fa ot-icon"></i>
              <FormattedMessage id={`${module_id}.read.from.sfi`} />
            </a>
          ) : (
            <div className="mt-1 userinfo-request__sent-info">
              <p>
                <FormattedMessage id={`${module_id}.sent.to.mail`} />
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export const UserInfoRequestList = ({ requests }) => {
  const hasActiveSuomiFiInbox = useSelector(state => state[USER].officialServices.isInboxActive);

  return (
    <div>
      {requests.map((r, idx) => (
        <UserInfoRequest
          request={r}
          key={idx}
          hasActiveSuomiFiInbox={hasActiveSuomiFiInbox}
        />
      ))}
    </div>
  );
};

export default UserInfoRequestList;
